import React from 'react';

import LevelSelector from '@styles/selectors/level';
import { View } from 'react-native';
import { getBoxShadowStyle } from '@styles/shadow';
import ColorWrapper from '@styles/colors';
import { SCREEN_BORDER_RADIUS } from '@v2/pages/common/constants/base.constants';

const LevelSelectorWrapper = ({
  panelViewMode,
  partId,
  noMachine,
  ncFile,
  ncFileId,
  partName,
  clampingTools = [],
  job,
  scale,
  font,
  isNCFile,
  blur,
  selectedItem,
  batchText,
  levelTabs,
  itemBG,
  withShadow,
  C,
  wrapperStyles,
  ...rest
}) => {
  return (
    <View style={[withShadow && getBoxShadowStyle({ type: 'Field', C }), withShadow && { borderRadius: scale(SCREEN_BORDER_RADIUS) }, wrapperStyles]}>
      <LevelSelector {...{ ...rest, tabs: levelTabs, big: rest.big ?? panelViewMode, scale, font, blur }} />
    </View>
  );
};

export default ColorWrapper(LevelSelectorWrapper);
